import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addContactButton: translate({ id: 'components.notificationEditor.addContactButton' }),
  }))

  return api
}
